import axios from "../customize/axios";

const loginAdmin = (valueLogin, password) => {
    try {
        return axios.post("/api/admin/login", { valueLogin, password })
    } catch (error) {
        console.log('Error at loginAdminUser in adminServices: ', error)
    }
}

const updateAdminInfo = (adminData) => {
    try {
        return axios.put('/api/admin/updateAdminInfo', { adminData })
    } catch (error) {
        console.log('Error at updateAdminInfo in adminServices: ', error);
    }
}

const updateUserInfo = (userData, oldUserCode) => {
    try {
        return axios.put('/api/admin/updateUserInfo', { userData, oldUserCode })
    } catch (error) {
        console.log('Error at updateUserInfo in adminServices: ', error);
    }
}

const fetchAllUsers = (page, limit) => {
    try {
        return axios.get(`/api/admin/listUser?page=${page}&limit=${limit}`)
    } catch (error) {
        console.log('Error at fetchAllUsers in adminServices: ', error)
    }
}

const fetchAllEmployees = (page, limit) => {
    try {
        return axios.get(`/api/admin/listEmployee?page=${page}&limit=${limit}`)
    } catch (error) {
        console.log('Error at fetchAllUsers in adminServices: ', error)
    }
}

const fetchUser = (userCode, page, limit) => {
    try {
        return axios.get(`/api/admin/user/infomation/${userCode}`)
    } catch (error) {
        console.log('Error at fetchUser in adminServices: ', error);
    }
}

const fetchAvatarUser = (fileName) => {
    try {
        return axios.get(`/api/admin/user/getAvatar/${encodeURIComponent(fileName)}`)
    } catch (error) {
        console.log('Error when fetching avatar user in adminServices: ', error);
    }
}

const fetchUserByUserCode = (userCode, page, limit) => {
    try {
        return axios.get(`/api/admin/user/find/?page=${page}&limit=${limit}&userCode=${userCode}`)
    } catch (error) {
        console.log('Error at fetchUser in adminServices: ', error);
    }
}

const fetchAllGroup = () => {
    try {
        return axios.get(`/api/admin/group/read`)
    } catch (error) {
        console.log('Error at fetchAllGroup in adminServices: ', error)
    }
}

const fetchAllParkingLot = () => {
    try {
        return axios.get(`/api/admin/listparkinglot/read`)
    } catch (error) {
        console.log('Error at fetchAllParkingLot in adminServices: ', error)
    }
}



const addNewAUser = (userData) => {
    try {
        return axios.post(`/api/admin/addAUser`, userData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    } catch (error) {
        console.log('Error at addNewAUser in adminServices: ', error);
    }
}

const addNewAEmployee = (userData) => {
    try {
        return axios.post(`/api/admin/addEmployee`, { userData })
    } catch (error) {
        console.log('Error at addNewEmployee in adminServices: ', error);
    }
}


const addListUsers = (listUsersData) => {
    try {
        return axios.post(`/api/admin/addListUsers`, listUsersData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    } catch (error) {
        console.log('Error at addListUsers in adminServices: ', error);
    }
}

const addListEmployees = (listUsersData) => {
    try {
        return axios.post(`/api/admin/addListEmployees`, listUsersData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    } catch (error) {
        console.log('Error at addListEmployees in adminServices: ', error);
    }
}

const deleteUser = (data) => {
    try {
        const queryString = new URLSearchParams(data).toString();
        console.log('query string: ', data);
        return axios.delete(`/api/admin/delete/user/?${queryString}`)
    } catch (error) {
        console.log('Error at deleteUser in adminServices: ', error);
    }
}

const deleteListUsers = (data) => {
    try {
        console.log('data deletelist:', data);
        return axios.post(`/api/admin/delete/list-user`, { data })
    } catch (error) {
        console.log('Error at deleteListUsers in adminServices: ', error);
    }
}

const fetchRevenueStats = () => {
    try {
        return axios.get('/api/admin/revenueStats');
    } catch (error) {
        console.log('Error at fetchRevenueStats in adminServices: ', error);
    }
};

const fetchListEWallets = () => {
    try {
        return axios.get('/api/admin/ewallets');
    } catch (error) {
        console.log('Error at fetchListEWallets in adminServices: ', error);
    }
};

const rechargeUserEWallet = (data) => {
    try {
        return axios.post('/api/admin/ewallet/recharge', data);
    } catch (error) {
        console.log('Error at rechargeUserEWallet in adminServices: ', error);
    }
};

const fetchListRegisteredVehicles = () => {
    try {
        return axios.get('/api/admin/registered-vehicles');
    } catch (error) {
        console.log('Error at fetchListRegisteredVehicles in adminServices: ', error);
    }
};

const updateVehicleStatus = (data) => {
    try {
        return axios.put('/api/admin/vehicle/status', data);
    } catch (error) {
        console.log('Error at updateVehicleStatus in adminServices: ', error);
    }
};

const updateRegisteredVehicle = (data) => {
    try {
        return axios.put('/api/admin/vehicle/update', data);
    } catch (error) {
        console.log('Error at updateRegisteredVehicle in adminServices: ', error);
    }
};

const updateEWalletStatus = (data) => {
    try {
        return axios.put('/api/admin/ewallet/status', data);
    } catch (error) {
        console.log('Error at updateEWalletStatus in adminServices: ', error);
    }
};

const fetchSupportTicketsAdmin = () => {
    try {
        return axios.get('/api/admin/support-tickets');
    } catch (error) {
        console.log('Error at fetchSupportTicketsAdmin in adminServices: ', error);
    }
};

const updateSupportTicketStatusAdmin = (ticketCode, status) => {
    try {
        return axios.put('/api/admin/support-tickets/status', { ticketCode, status });
    } catch (error) {
        console.log('Error at updateSupportTicketStatusAdmin in adminServices: ', error);
    }
};

export {
    loginAdmin,
    updateAdminInfo,
    updateUserInfo,
    fetchAllUsers,
    fetchAllEmployees,
    fetchUser,
    fetchUserByUserCode,
    fetchAllGroup,
    fetchAllParkingLot,
    addNewAUser,
    addNewAEmployee,
    addListUsers,
    addListEmployees,
    deleteUser,
    deleteListUsers,
    fetchAvatarUser,
    fetchRevenueStats,
    fetchListEWallets,
    rechargeUserEWallet,
    fetchListRegisteredVehicles,
    updateVehicleStatus,
    updateRegisteredVehicle,
    updateEWalletStatus,
    fetchSupportTicketsAdmin,
    updateSupportTicketStatusAdmin
}
